import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetSummaryComponent } from './asset-summary/asset-summary.component';
import { IdentifyAssetsModule } from '../identify-assets/identify-assets.module';
import { LayoutComponent } from './layout/layout.component';
import { SummaryDetailTemplateComponent } from './summary-detail-template/summary-detail-template.component';
import { PublishComponent } from './publish/publish.component';
import { PublishStatusComponent } from './publish-status/publish-status.component';

@NgModule({
  imports: [
    CommonModule,
    IdentifyAssetsModule
  ],
  exports: [LayoutComponent],
  declarations: [LayoutComponent, AssetSummaryComponent, SummaryDetailTemplateComponent, PublishComponent, PublishStatusComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ViewAssetsModule { }
